export const getColorFromString = (str?: string | null): string => {
  if (str === undefined || str === null) {
    return 'hsl(216,24%, 96%)'
  }
  let hash = 0
  str = str.trim().toLowerCase()
  if (str.length == 0) return hash.toString()
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
    hash = hash & hash // Convert to 32bit integer
  }
  const shortened = Math.abs(hash) % 360
  return 'hsl(' + shortened + ',35%, 60%)'
}
